import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarService } from './sidebar.service';
import { SidebarComponent } from './sidebar.component';
import { SidebarButtonComponent } from './sidebar-button.component';

@NgModule({
  declarations: [SidebarComponent, SidebarButtonComponent],
  imports: [CommonModule],
  providers: [SidebarService],
  exports: [SidebarComponent, SidebarButtonComponent],
})
export class SidebarModule {}
